import styled from 'styled-components';

// import headerBackground from '../../assets/images/headerImage.svg';
import colors from '../../assets/theme/colors';

const hasMobMode =
  window.innerHeight / window.innerWidth < 2 && window.innerWidth < 768;

const hasMobSecondMode =
  window.innerHeight / window.innerWidth > 1.7 && window.innerWidth < 768;
export const Wrapper = styled('header')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '155px',
  position: 'relative',
  background: `${colors.primaryColor}`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundPosition: 'center center',
  width: '100%',
  mixBlendMode: 'hard-light',
});

export const BurgerButton = styled('button')({
  position: 'absolute',
  background: 'none',
  border: 'none',
  right: '20px',
  top: '34%',
  cursor: 'pointer',
  padding: '0px',
  margin: '0px',
  '@media screen and (min-width: 1100px)': {
    display: 'none',
  },
});
export const ArrowButton = styled('button')({
  position: 'absolute',
  background: 'none',
  border: 'none',
  left: '20px',
  top: '34%',
  cursor: 'pointer',
  padding: '0px',
  margin: '0px',
  '@media screen and (min-width: 1100px)': {
    display: 'none',
  },
});
export const ImgLogoFanVote = styled('img')({
  margin: hasMobMode ? '0 auto' : '',
  maxWidth: '45vw',
  '@media screen and (min-width: 1250px)': {
    width: '100%',
  },
});
export const LogoImage = styled('img')({
  margin: hasMobMode ? '0 auto' : '',
  padding: '16px 0',

  '@media screen and (min-width: 1100px)': {
    width: '100%',
    padding: '0px',
  },
});

type FlexContainerProps = {
  customStyles?: { [key: string]: string | number };
};

export const HeaderContainer = styled('div')(({ theme }) => ({
  width: '100%',
  position: 'relative',
  '::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    // background: `${colors.primaryColor}`,
    opacity: '0.5',
    zIndex: 1,
  },

  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundPosition: 'center center',
  '@media screen and (min-width: 1100px)': {
    width: '100%',
    height: '100%',
  },
}));

export const FlexContainer = styled('div')<FlexContainerProps>(({
  customStyles,
}) => {
  return {
    display: 'flex',
    alignItems: 'center',
    ...customStyles,
  };
});

export const HeaderTopContainer = styled('div')({
  display: 'flex',
  width: '100%',
  zIndex: 2,
  alignItems: 'center',
  padding: hasMobMode ? (hasMobSecondMode ? '' : '') : '',
  position: 'relative',
  justifyContent: 'center',
  background: 'rgba(18, 31, 255, 0.5)',
  '@media screen and (min-width: 1100px)': {
    padding: '',
    background: 'transparent',
  },
});
